<template>
  <div
    :class="$style.wrapper"
  >
    <SidebarSection title="Details">
      <FormWrapper>
        <InputText
          ref="firstName"
          v-model="firstname"
          data-test-id="AdministratorSidebar__FirstName"
          :isReadonly="readonly"
          label="First Name"
          name="first name"
        />
        <InputText
          ref="lastName"
          v-model="lastname"
          data-test-id="AdministratorSidebar__LastName"
          :isReadonly="readonly"
          label="Last Name"
          name="last name"
        />
        <InputText
          ref="email"
          v-model="email"
          data-test-id="AdministratorSidebar__Email"
          :isReadonly="readonly"
          label="Administrator Email Address"
          name="administrator email address"
          rules="email|required"
        />
      </FormWrapper>
    </SidebarSection>
    <SidebarSection
      v-if="canViewRoles"
      title="Permissions"
    >
      <RoleSelect
        ref="role"
        v-model="role"
        data-test-id="AdministratorSidebar__Role"
        :isReadonly="readonly"
        label="Role"
        name="role"
        rules="required"
      />
    </SidebarSection>
    <AdministratorMFASection
      ref="mfa"
      v-model="item"
      :class="$style.sidebar"
      :isDisabled="readonly"
      :isUpdating="isUpdating"
    />
    <AdministratorAccountSection
      v-if="value._id"
      ref="account"
      :administratorId="value._id"
      :buttonDisabled="readonly"
    />
  </div>
</template>

<script>
import {
  InputText,
  SidebarSection,
} from '@jumpcloud/ui-components';

import AdministratorAccountSection from 'client/settings/AdministratorSettings/AdministratorSidebar/AdministratorAccountSection.vue';
import AdministratorMFASection from 'client/settings/AdministratorSettings/AdministratorSidebar/AdministratorMFASection.vue';
import FormWrapper from 'client/components/Forms/FormWrapper.vue';
import RoleSelect from 'client/settings/AdministratorSettings/AdministratorSidebar/RoleSelect.vue';
import createComputedObjectBinding from 'client/util/createComputedObjectBinding';

export default {
  name: 'AdministratorForm',

  components: {
    AdministratorAccountSection,
    AdministratorMFASection,
    FormWrapper,
    InputText,
    RoleSelect,
    SidebarSection,
  },

  returnToRoute: '',

  props: {
    canViewRoles: Boolean,
    isUpdating: Boolean,
    readonly: Boolean,
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    email: {
      ...createComputedObjectBinding('email'),
    },

    firstname: {
      ...createComputedObjectBinding('firstname'),
    },

    item: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', {
          ...this.value,
          ...newValue,
        });
      },
    },

    lastname: {
      ...createComputedObjectBinding('lastname'),
    },

    role: {
      ...createComputedObjectBinding('role'),
    },
  },
};
</script>

<style module scoped>
.wrapper {
  height: 100%;
}
</style>
